import { useAppContext } from "@/contexts/AppContext";
import { isCapacitor } from "@/lib/client";
import { NamedRoute, RouteMap } from "@/Routes";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { zaraz } from "zaraz-ts";

export const Zaraz = () => {
    const { user, currentDevice } = useAppContext();
    const location = useLocation();
    const [_, setSentRootOnce] = useState(false);

    const pageView = useCallback(() => {
        if (window.zaraz) {
            const page_location = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
            zaraz.track("page_view", {
                page_location,
                page_title: page_location,
                user_id: user?.userId,
                device_id: currentDevice().deviceId,
            });
        }
    }, [currentDevice, user]);

    useEffect(() => {
        // If on the homepage, we don't want to track page views
        if (location.pathname === "/") {
            setSentRootOnce((p) => {
                if (!p) {
                    pageView();

                    if (isCapacitor()) {
                        zaraz.track("app_opened");
                    }
                }
                return true;
            });
        } else {
            pageView();
        }

        // Some other pages we want to track other events
        if (location.pathname === RouteMap.Path(NamedRoute.Plans)) {
            zaraz.track("view_item_list");
        } else if (location.pathname === RouteMap.Path(NamedRoute.Pro)) {
            zaraz.track("view_item");
        }
    }, [location, pageView]);

    useEffect(() => {
        zaraz.set("user_id", user?.userId);
        zaraz.set("device_id", currentDevice().deviceId);
    }, [currentDevice, user]);

    return <></>;
};
